import { Box, CircularProgress } from "@mui/material";
import React from 'react'
import { ResponsiveBar } from '@nivo/bar';
import { linearGradientDef } from '@nivo/core'

const CountedStopsChart = ({ data, xAxisLabel }) => {


  function processData(dataToProcess) {
    let groupedDataTemp = [];
    
    const filteredData = dataToProcess.filter(value => value.showMachinePageStatisticsBool === true);

    filteredData.reduce(function (res, value) {
      if (!res[value.stopReasonCodeName]) {
        res[value.stopReasonCodeName] = { stopReasonCodeName: value.stopReasonCodeName, count: 0, countColor: value.stopReasonCodeColor };
        groupedDataTemp.push(res[value.stopReasonCodeName]);
      }
      res[value.stopReasonCodeName].count += 1;
      return res;
    }, {});
    groupedDataTemp.sort((a, b) => a.count - b.count);

    return groupedDataTemp;
  }

  if (data.isLoading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="73vh">
        <CircularProgress color="secondary" />
      </Box>
    )
  } else {

    const lineGraphSettings = {
      theme: {
        textColor: '#ffffff',
        tooltip: {
          color: '#000000'
        }
      },
    };


    let content = <ResponsiveBar
      data={processData(data.data)}
      keys={['count']}
      indexBy="stopReasonCodeName"
      margin={{ top: 5, right: 20, bottom: 60, left: 120 }}
      padding={0.3}
      theme={lineGraphSettings.theme}

      layout="horizontal"
      valueScale={{ type: 'linear' }}
      indexScale={{ type: 'band', round: true }}
      colors={({ id, data }) => data[`${id}Color`]}

      defs={[
        linearGradientDef('barGradient', [
          { offset: 0, color: 'inherit' },
          { offset: 50, color: 'inherit' },
          { offset: 100, color: '#dddddd' },
        ],
          {
            gradientTransform: 'rotate(225 0.5 0.5)'
          }),
        {
          id: 'col',
          background: 'inherit',
          color: "inherit",
          size: 4,
          padding: 1,
          stagger: true
        }
      ]}
      fill={[
        { match: { id: 'countzzz' }, id: 'barGradient' }
      ]}
      borderColor={{
        from: 'color',
        modifiers: [
          [
            'darker',
            1.6
          ]
        ]
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: xAxisLabel,
        legendPosition: 'middle',
        legendOffset: 32,
        truncateTickAt: 0,
        color: '#ff0000'
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendPosition: 'middle',
        legendOffset: -40,
        truncateTickAt: 0
      }}
      enableGridX={true}
      enableGridY={false}
      labelSkipWidth={12}
      labelSkipHeight={12}
      role="application"
      ariaLabel="Nivo bar chart demo"
      barAriaLabel={e => e.stopReasonCodeName + ": " + e.count}
    />

    return content;

  }

}

export default CountedStopsChart;
